import { useEffect } from "react";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "~/packages/msalInstance";
import history from "~/packages/history";
import { useSelector } from "react-redux";

const Login = () => {
  useMsalAuthentication(InteractionType.Redirect, loginRequest);

  const { accounts } = useMsal();
  const { isAuthenticated } = useSelector((s: ReduxStore.State) => s.auth);

  useEffect(() => {
    if (accounts?.length > 0 && isAuthenticated) {
      history.push("/");
    }
  }, [accounts, isAuthenticated]);

  return null;
};

export default Login;